import "select2/dist/js/select2.full.min";
import "select2/dist/js/i18n/pt-BR";
$(document).ready(function() {
  $(".select2").select2({
    theme: "bootstrap4",
    language: "pt-BR"
  });
});
